import { gql } from '@apollo/client';

export const GET_ALL_MEAL_PLANS = gql`
  query GetAllMealPlans($filter: MealPlanFilterInput) {
    getAllMealPlans(filter: $filter) {
      id
      name
      mealType
      protein
      carbs
      fats
      total_kcal
      content
      expertAdvice
      createdAt
      updatedAt
      thumbnailURL
    }
  }
`;

export const CREATE_MEAL_PLAN = gql`
  mutation CreateMealPlan($input: MealPlanCreateInput!) {
    createMealPlan(input: $input) {
      id
      name
      mealType
      protein
      carbs
      fats
      total_kcal
      content
      expertAdvice
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_MEAL_PLAN = gql`
  mutation UpdateMealPlan($updateMealPlanId: ID!, $input: MealPlanUpdateInput!) {
    updateMealPlan(id: $updateMealPlanId, input: $input) {
      id
      name
      mealType
      protein
      carbs
      fats
      total_kcal
      content
      expertAdvice
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_MEAL_PLAN = gql`
  mutation DeleteMealPlan($deleteMealPlanId: ID!) {
    deleteMealPlan(id: $deleteMealPlanId)
  }
`;
